import api from './api';

export const ethicalAPI = {
  get: (clientId) => api.get(`/api/clients/${clientId}/ethical-letter`),
  list: (clientId) => api.get(`/api/clients/${clientId}/ethical-letters`),
  generate: (clientId, data) => api.post(`/api/clients/${clientId}/ethical-letter/generate`, data),
  edit: (letterId, data) => api.patch(`/api/ethical-letters/${letterId}`, data),
  send: (letterId) => api.post(`/api/ethical-letters/${letterId}/send`),
  respond: (letterId, data) => api.post(`/api/ethical-letters/${letterId}/response`, data),
  downloadPdf: (letterId) => api.get(`/api/ethical-letters/${letterId}/pdf`, { responseType: 'blob' }),
};

export const ETHICAL_STATUS_META = {
  draft: { label: 'Draft', color: 'bg-muted text-muted-foreground' },
  sent: { label: 'Sent — awaiting response', color: 'bg-blue-100 text-blue-800' },
  cleared: { label: 'Clearance received', color: 'bg-green-100 text-green-800' },
  objection: { label: 'Objection raised', color: 'bg-red-100 text-red-700' },
};

export const downloadEthicalPdf = async (letterId, filename) => {
  const res = await ethicalAPI.downloadPdf(letterId);
  const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename || 'ethical-letter'}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
